/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGoCampaign_OfficeGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Office Group Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, July 11, 2019 - 02:26:10 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/11/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GoCampaign_OfficeGroupList = Loadable({
    loader: () => import('../containers/GoCampaign_OfficeGroups/GoCampaign_OfficeGroupListContainer'),
    loading: Loading,
});

export const GoCampaign_OfficeGroupForm = Loadable({
    loader: () => import('../containers/GoCampaign_OfficeGroups/GoCampaign_OfficeGroupEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGoCampaign_OfficeGroups.js